var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKotlinSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 73.714,
    y1: 910.226,
    x2: 105.452,
    y2: 878.134,
    gradientTransform: "translate(-64.139 -782.556) scale(0.893)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0296d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8371d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 69.813,
    y1: 905.226,
    x2: 102.279,
    y2: 875.745,
    gradientTransform: "translate(-64.139 -782.556) scale(0.893)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cb55c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28e0e"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_kotlin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2,2V30H30v-.047l-6.95-7L16.1,15.946l6.95-7.012L29.938,2Z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.318,2,2,16.318V30h.124L16.132,15.992l-.031-.031L23.05,8.95,29.938,2Z",
    style: {
      fill: "url(#b)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlinSvgrepoCom);
export default __webpack_public_path__ + "static/media/kotlin-svgrepo-com.8da7a916f2ff39b5c052df32d968eece.svg";
export { ForwardRef as ReactComponent };